<template>
  <bottom-sheet
    :visible="visible"
    min-height="min-h-[200px]"
    @close="$emit('close')"
  >
    <div class="-mt-2 flex flex-col items-center gap-2 px-2">
      <img
        class="h-8"
        src="@/assets/loads/triumph-full-blue.svg"
        alt="triumph logo"
      />
      <p class="text-xs font-normal text-neutral-subtle-bold">
        Learn more about factoring with Triumph.
      </p>

      <div class="h-14">
        <button-main
          class="my-2 mb-8 flex !h-10 items-center gap-2 !py-0 text-1md !text-black"
          @click="handleApplyWithHighway"
        >
          <img
            class="h-6"
            src="@/assets/black-highway-logo.svg"
            alt="highway logo"
          />
          <p class="leading-none">Apply with Highway</p>
        </button-main>
      </div>

      <div class="flex items-center gap-1">
        <img
          class="h-3.5"
          src="@/assets/loads/clock-icon.svg"
          alt="clock icon"
        />
        <p class="text-xs font-normal text-neutral-subtle-bold">
          Takes just 60 seconds
        </p>
      </div>
    </div>
  </bottom-sheet>
</template>

<script>
import BottomSheet from '../BottomSheet.vue';
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'FactoringBottomSheet',
  components: {
    BottomSheet,
    ButtonMain,
  },
  props: {
    visible: Boolean,
  },
  emits: ['close'],
  setup() {
    const handleApplyWithHighway = () => {
      // emit('close');
    };

    return {
      handleApplyWithHighway,
    };
  },
};
</script>
